import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'
import { clearProjectId, createProject, setCurrentProjectId } from '../../../../store/actions/projectActions';
import * as MDICONS from '@material-ui/icons';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../../constants/routes';
import Loader from 'react-loader-spinner';
import $ from 'jquery';
import { common } from '@material-ui/core/colors';
const EditButton = styled.div`
    .btn {
        color: #fafafa;
        border-color: #040926;
        background-color: #040926;
        margin: 2px;

        &:hover {
            background-color: #040850;
        }

        &:active {
            background-color: #040850;
        }
    }
`;


class CreateProjectModal extends Component {

    constructor(props) {
        super()
        this.state = {
            projectTitle: "",
            email: "",
            phone: "",
            selectedFiles: [],
            selectedFilesNames: [],
            url: '',
            isTagCreate: false,
            isFloorsCreate: false,
            isMapAddition: false,
            tagCategory: "",
            openCardToggle: true,
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        // console.log("CREATING PROJECT...");
        const { tagCategory, isFloorsCreate, isMapAddition } = this.state;
        const {commons} = this.props;
        const {drawing} = commons;
       
        var selectedFiles = this.state.selectedFiles;
        if (isMapAddition) {
            if (selectedFiles.length <= 0) {
               alert(`Please attach at least one ${drawing} to continue, otherwise uncheck the option` )
            }
        }
        else {
            const { userData, companyData } = this.props;
            const projectData = {
                projectTitle: this.state.projectTitle ?? "",
                email: this.state.email ?? "",
                phone: companyData.phone ?? "",
            };
            this.props.createProject(userData, companyData, projectData, selectedFiles, tagCategory, isFloorsCreate);
        }



    }

    onChangeHandler = (e) => {
        const { selectedFiles, selectedFilesNames } = this.state;
        var newSelectedFiles = selectedFiles;
        var newSelectedFilenames = selectedFilesNames;

        if (this.maxSelectFile(e) && this.checkMimeType(e) && this.checkFileSize(e)) {
            var filteredFiles = this.removeRedundantFilenames(e.target.files);
            var filteredFilenames = this.getFilenames(filteredFiles)

            newSelectedFiles = [...newSelectedFiles, ...filteredFiles];
            newSelectedFilenames = [...newSelectedFilenames, ...filteredFilenames];

            this.setState(() => ({
                selectedFiles: newSelectedFiles,
                selectedFilesNames: newSelectedFilenames,
            }));
        }
    }
    getFilenames = (files) => {
        var filenames = [];
        files.forEach((file) => filenames.push(this.processFilenames(file.name)));
        return filenames;
    }
    processFilenames = (filename) => {
        return this.removePdfExt(this.toLowercaseWithoutSpaces(filename));
    }
    /// README: UTILS
    toLowercaseWithoutSpaces = (val) => {
        return val.replaceAll(/[/\-.\s]/g, '').toLowerCase();
    }

    removePdfExt = (val) => {
        const extLength = 'pdf'.length;
        return val.substring(0, val.length - extLength);
    }
    maxSelectFile = (e) => {
        let files = e.target.files
        if (files.length > 100) {
            const msg = 'Only 100 pdf files can be uploaded at a time';
            alert(msg);
            e.target.value = null
            return false;
        }
        return true;
    }

    checkFileSize = (e) => {
        let files = e.target.files
        let size = 10485760;
        let err = "";
        for (var x = 0; x < files.length; x++) {
            if (files[x].size > size) {
                err = 'File is too large, please pick a smaller file(limit 10mb)\n';
                alert(err);
            }
        };
        if (err !== '') {
            e.target.value = null
            return false
        }
        return true;
    }

    checkMimeType = (e) => {
        let files = e.target.files
        let err = ''
        const types = ['application/pdf']
        for (var x = 0; x < files.length; x++) {
            if (!types.includes(files[x].type)) {
                err = 'File is not in a supported format\n';
                alert(err);
            }
        };
        if (err !== '') {
            e.target.value = null // discard selected file
            return false;
        }
        return true;
    }

    /// TODO: NEED TO REVISIT (ZAIN)
    componentDidMount() {
        this.props.clearProjectId();
    }

    handleTagCategories = (e) => {
        this.setState({
            [e.target.id]: !this.state.isTagCreate
        })
    }
    handleSegmentCreation = (e) => {
        this.setState({
            [e.target.id]: !this.state.isFloorsCreate
        })
    }
    handleFileAttachment = (e) => {
        this.setState({
            [e.target.id]: !this.state.isMapAddition
        })
    }

    removeRedundantFilenames = (files) => {
        const { selectedFiles } = this.state;

        // check if files are already not in state
        var filteredFiles = [...files].filter(s => selectedFiles.every(t => {
            return s.name !== t.name
        }));
        return filteredFiles;
    }

    handleCardToggle = () => {
        this.setState({
            openCardToggle: !this.state.openCardToggle,
        }, () => {
            console.log(this.state.openCardToggle)
        })
    }
    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
        const { email } = this.props.companyData;
        this.setState({ email });
    }
    render() {
        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: seeing the state of form (do styling adjustments but be cautious with state)
        ///
        const { userId, modalWidth, modalHeight, modalTitleStyle, modalInfoTextStyle, productOrder, themeColors, companyData, project, commons, commonQuestions } = this.props;
        const { isProjectCreating, isFilesAdded, isProjectCreated, proid } = this.props.project;
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }
        const relevantSubmitComponent = !isProjectCreating ? <button className="btn btn-dark btn-sm border-dark" style={{ borderRadius: '5px' }} type="submit" disabled={isProjectCreating}>Confirm and create</button> : <button className="btn btn-dark btn-sm" type="button" disabled>
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            &nbsp; Creating new {commons.project}
        </button>

        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: return the form
        ///
        const formLabelStyle = {
            fontSize: "12px",
            fontWeight: "bold",
        };

        const zStyle = {
            left: "400px",
            right: "0px",
            top: "160px",
            position: "absolute",
            zIndex: "auto",
        };



        const { selectedFiles, selectedFilesNames } = this.state;
        const relevantErrorComponent = <div className="dynamicModalContainerSm">
            <div className="dynamicModalSm">
                <p style={modalTitleStyle}>Cannot create {commons.project}</p>
                <p style={modalInfoTextStyle}>Please purchase a subscription or extend your limits with topup.</p>
                <br />
                <Link to={ROUTES.HOME_COMPANY}><button className="btn btn-dark btn-sm">Visit company dashboard</button></Link>
            </div>
        </div>;

        if (productOrder && companyData && commonQuestions) {
            const { tagCount, tagLimit, companyMembersLimit } = productOrder;
            const { totalActiveCompanyMembers } = companyData;
            const tagLimitReached = tagCount > tagLimit ? true : false;
            const companyMemberLimitReached = companyMembersLimit === "-1" ? false : totalActiveCompanyMembers > companyMembersLimit ? true : false;
            let boughtOrderId = 'boughtSubscription' in companyData ? companyData.boughtSubscription.orderId : null;
            const subscriptionBoughtActive = boughtOrderId ? companyData.boughtSubscription.applied : false
            const showSubscriptionModal = !subscriptionBoughtActive || tagLimitReached || companyMemberLimitReached
            const { isFloorCreate, isMapAddition, isTagCreate, isTagCreateSub, isFloorCreateSub, isMapAdditionSub, isTagCreatePlaceholder, quickStartTitle, quickStartSubtitle } = commonQuestions.projectCreation;
            if (showSubscriptionModal) {
                return (
                    <React.Fragment>{relevantErrorComponent}</React.Fragment>
                )
            }
            else {
                return (
                    <div className="dynamicModalContainer">
                        <div className="dynamicModalSm">
                            <div className="px-3">
                                <p style={modalTitleStyle}>Create new {commons.project}</p>
                                {/* Moved out of form to prevent onSubmit handle */}
                                {/* MAIN FORM */}
                                <form onSubmit={this.handleSubmit}>
                                    {/* ProjectTitle */}
                                    <div className="form-group text-left pb-3">
                                        <label htmlFor="projectTitle" style={formLabelStyle}>{commons.uproject} title *</label>
                                        <input type="text" className="form-control bg-light" id="projectTitle" onChange={this.handleChange} required disabled={isProjectCreated} />
                                    </div>

                                    {/* Email Address */}
                                    <div className="form-group text-left pb-3">
                                        <label htmlFor="email" style={formLabelStyle}>Email address *</label>
                                        <input type="text" className="form-control bg-light" id="email" onChange={this.handleChange} value={this.state.email} required disabled={isProjectCreated} />
                                    </div>

                                    {/* Phone No */}
                                    {/* <div className="form-group text-left pb-3">
                                        <label htmlFor="phone" style={formLabelStyle}>Company's phone</label>
                                        <input type="tel" className="form-control bg-light" id="phone" placeholder="Hint: +441234567899" pattern="[+]{1}[0-9]{2,}" onChange={this.handleChange} required disabled={isProjectCreated} />
                                    </div> */}

                                    <div className="form-group text-left pb-3">
                                        <label className="form-check-label" style={formLabelStyle}>
                                            {quickStartTitle} <MDICONS.Help style={{ scale: "0.8" }} data-toggle="tooltip" data-placement="top" title={`${quickStartSubtitle}`} />
                                        </label>
                                    </div>

                                    {/* Categories */}
                                    <div className="form-group text-left pb-3">
                                        <div className="form-check" style={{ display: 'inline' }}>
                                            <input className="form-check-input" type="checkbox" id="isTagCreate" onChange={this.handleTagCategories} />
                                            <label className="form-check-label" htmlFor="isTagCreate">
                                                {isTagCreate} <MDICONS.Help style={{ scale: "0.8" }} data-toggle="tooltip" data-placement="top" title={`${isTagCreateSub}`} />
                                            </label>
                                        </div>
                                    </div>
                                    {
                                        this.state.isTagCreate ?
                                            <div className="form-group text-left pb-3">
                                                <label htmlFor="tagCategory" style={formLabelStyle}>{commons.utagCategories} *</label>
                                                <input type="text" className="form-control bg-light" id="tagCategory" onChange={this.handleChange} required disabled={isProjectCreated} placeholder={`${isTagCreatePlaceholder}`} />
                                            </div>

                                            : <React.Fragment />
                                    }


                                    {/* Segment Creation */}
                                    <div className="form-group text-left pb-3">
                                        <div className="form-check" style={{ display: 'inline' }}>
                                            <input className="form-check-input" type="checkbox" id="isFloorsCreate" onChange={this.handleSegmentCreation} />
                                            <label className="form-check-label" htmlFor="isFloorsCreate">
                                                {isFloorCreate}  <MDICONS.Help style={{ scale: "0.8" }} data-toggle="tooltip" data-placement="top" title={`${isFloorCreateSub}`} />
                                            </label>
                                        </div>
                                    </div>


                                    {/* File upload button */}
                                    <div className="form-group text-left pb-3">
                                        <div className="form-check" style={{ display: 'inline' }}>
                                            <input className="form-check-input" type="checkbox" id="isMapAddition" onChange={this.handleFileAttachment} />
                                            <label className="form-check-label" htmlFor="isMapAddition">
                                                {isMapAddition}  <MDICONS.Help style={{ scale: "0.8" }} data-toggle="tooltip" data-placement="top" title={`${isMapAdditionSub}`} />
                                            </label>
                                        </div>
                                    </div>



                                    {this.state.isMapAddition ?
                                        <div className="form-group text-left pb-3">
                                            <label style={formLabelStyle}>Attach files (supported: PDF)</label>
                                            <br />
                                            <label htmlFor="files">
                                                <span className="btn btn-outline-dark btn-sm border-dark" style={{ textAlign: 'center' }}>
                                                    <MDICONS.Add /> &nbsp;Upload files
                                                </span>
                                            </label>

                                            <ul className="list-group align-items-start list-group-flush">
                                                {selectedFiles.map((fileName, i) => (
                                                    <li style={{ fontSize: "13px" }} className="list-group-item py-2 border-0" ng-repeat="i in filters" key={i}>
                                                        <b>{i + 1}. </b>{`${fileName.name}`}
                                                        <br></br>
                                                        <span style={{ fontSize: "10px", color: "GrayText", fontStyle: "italic" }}>(Formatted as: {selectedFilesNames[i]})</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        : <React.Fragment />
                                    }


                                    <div className="form-group text-left">
                                        <input type="file" className="file" id="files" multiple onChange={this.onChangeHandler} style={{ display: 'none', fontWeight: "bold", fontSize: "18px" }} disabled={isProjectCreating || isProjectCreated} />
                                    </div>
                                    {relevantSubmitComponent}
                                </form>
                            </div>
                        </div>
                    </div>
                )
            }

        }
        else {
            return (
                <React.Fragment>{relevantErrorComponent}</React.Fragment>
            )
        }



    }
}
const mapStateToProps = (state) => {
    // console.log(state.firebase.data.Company)
    return {
        auth: state.auth,
        themeColors: state.theme,
        userData: state.firebase.profile,
        companyData: state.firestore.data.Company,
        project: state.project,
        userId: state.firebase.auth.uid,
        modalWidth: state.appControl.modalWidthMedium,
        modalHeight: state.appControl.modalHeightMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        company: state.company,
        productOrder: state.firestore.data.ProductOrder,
        commons: state.commons,
        commonQuestions: state.firestore.data.CommonQuestions,
        formLabelStyle: state.appControl.formLabelStyle,
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        createProject: (userData, companyData, projectData, selectedFiles, tagCategory, isFloorsCreate) => dispatch(createProject(userData, companyData, projectData, selectedFiles, tagCategory, isFloorsCreate)),
        setCurrentProjectId: (proid) => dispatch(setCurrentProjectId(proid)),
        clearProjectId: () => dispatch(clearProjectId()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProjectModal);
